module.exports = __webpack_public_path__ + "static/media/linkedin.3282f4b1.png";